import { DataBean } from "../DataBean";

export class UpdateIcomeDoc extends DataBean {



    public async updateIncomeDocumentState(iadDocument:any,iadDocumentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateIncomeDocumentState_Number_java.util.Date", [iadDocument,iadDocumentDate]);
    }
    
}